import { Grid } from "@mui/material";
import BringValueInput from "qubCommon/Inputs/BringValueInput";
import TextInput from "qubCommon/Inputs/TextInput";
import { useForm, FormProvider } from "react-hook-form";

const DummyForm = () => {
  const testForm = useForm();

  return (
    <Grid container>
      <FormProvider {...testForm}>
        <Grid item sx={{ padding: 4 }} xs={6}>
          <BringValueInput
            rowDirection
            id="Name"
            name="Name"
            size="small"
            label="Επωνυμία"
            fullWidth
          />
        </Grid>
        <Grid item sx={{ padding: 4 }} xs={6}>
          <BringValueInput
            rowDirection
            id="AFM"
            name="AFM"
            size="small"
            label="ΑΦΜ"
            fullWidth
          />
        </Grid>
        <Grid item sx={{ padding: 4 }} xs={6}>
          <TextInput
            rowDirection
            id="DOY"
            name="DOY"
            size="small"
            label="ΔΟΥ"
            fullWidth
          />
        </Grid>

        <Grid item sx={{ padding: 4 }} xs={6}>
          <TextInput
            rowDirection
            id="Address"
            name="Address"
            size="small"
            label="Διεύθυνση"
            fullWidth
          />
        </Grid>
      </FormProvider>
    </Grid>
  );
};

export default DummyForm;
